import * as S from './styles';
import Logo from '#assets/svg/logo.svg';
import TopLogo from '#assets/svg/landing_top_logo.svg';
import { ReactComponent as LandingP } from '#assets/svg/landing_top_p.svg';

import { Text } from '#atoms';
import styled from 'styled-components';
import { useNavigate } from 'react-router';
export const LandingTop = () => {
  const navigate = useNavigate();
  return (
    <S.Container>
      <S.LandingTop>
        <S.Header>
          <img src={Logo} width={70} height={22} />
          <S.HeaderText>
            <Text
              className="px-[12px]"
              onClick={() =>
                window.open('http://pf.kakao.com/_cxeCPG/chat', '_blank')
              }
            >
              문의하기
            </Text>
            <Text className="px-[12px]" onClick={() => navigate('/sign')}>
              로그인
            </Text>
          </S.HeaderText>
        </S.Header>
        <S.TextGradation>억대 연봉 트레이너의 비밀</S.TextGradation>
        <S.LandingTopText className="mt-[40px]">
          트레이너를 위한
        </S.LandingTopText>
        <S.LandingTopText>올인원 브랜딩 솔루션</S.LandingTopText>
      </S.LandingTop>
      <img src={TopLogo} style={{ marginTop: '83px ' }} />
      <TopAbsolute />
    </S.Container>
  );
};

const TopAbsolute = styled(LandingP)`
  padding: 0 30px 0 0;
  width: 100%;
  position: absolute;
  top: 550px;
  @media (max-width: 475px) {
    top: 280px;
  }
`;
